import { css } from "@emotion/react";

type Position = "20%" | "50%" | "80%";

interface Content {
  position: Position;
  bgImage?: string;
  height?: string;
}

export const stySaveDate = css`
  height: 100vh;
  position: relative;
  color: #f9f9f9;
`;

export const stySaveDateContent = ({
  position,
  bgImage,
  height,
}: Content) => css`
  position: absolute;
  width: 100%;
  top: ${position};
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: black;
  text-align: center;
  height: ${height ? height : "20%"};
  background-color: #6b6445;
  ${bgImage &&
  ` background-image: url(${bgImage});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;`}

  h4 {
    margin: 0;
  }
`;
